import { styled } from '@styles';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: -5.5px -3px;
`;
